(() => {
  const MAX_CHARS = 12;

  const getSelectedVersion = () => {
    const checkedInput = document.querySelector(
      'input[name*="Version"]:checked, input[name*="version"]:checked'
    );

    if (checkedInput) return checkedInput.value;

    const selectedOption = document.querySelector(
      'select[name*="Version"], select[name*="version"]'
    );

    if (selectedOption) return selectedOption.value;

    return '';
  };

  const updateCharacterCounter = (input) => {
    const field = input.closest('.wtm-personalisation__field');
    if (!field) return;

    const counter = field.querySelector('[data-character-current]');
    if (!counter) return;

    counter.textContent = input.value.length;
  };

  const updatePersonalisation = () => {
    const selectedVersion = getSelectedVersion().toLowerCase();

    const isPersonalised =
      selectedVersion === 'personalised' ||
      selectedVersion === 'personalized';

    document.querySelectorAll('[data-wtm-personalisation]').forEach((block) => {
      const inputs = block.querySelectorAll('[data-wtm-personalisation-input]');

      block.hidden = !isPersonalised;

      inputs.forEach((input) => {
        input.disabled = !isPersonalised;
        input.maxLength = MAX_CHARS;

        if (!isPersonalised) {
          input.value = '';
        }

        updateCharacterCounter(input);
      });
    });
  };

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-wtm-personalisation-input]')) return;
    updateCharacterCounter(event.target);
  });

  document.addEventListener('DOMContentLoaded', updatePersonalisation);
  document.addEventListener('change', updatePersonalisation);

  document.addEventListener('click', () => {
    window.setTimeout(updatePersonalisation, 50);
  });
})();